module.exports = __webpack_public_path__ + "static/img/fire.405f1ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fire.png
// module id = 04Pg
// module chunks = 1